import React from 'react';
import { Typography } from '@mui/material';

export default function SettingsGeneralPage() {
  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>General</Typography>
      <Typography color="text.secondary">More settings will be available here in a future release.</Typography>
    </>
  );
}
